<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   icon="components_legend"></tm-menubar-button>
